<div class="success">
    <div class="icon-container">
        <mat-icon>check</mat-icon>
    </div>
    <span>{{ I18N.CALLBACK_REQUEST_GENERATED | i18n | async }}</span>
</div>
